const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  userid: state => state.user.userid,
  usernm: state => state.user.usernm,
  deptid: state => state.user.deptid,
  limittype: state => state.user.limittype,
  mobiletel: state => state.user.mobiletel,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs,
  warnswitchsta: state => state.vedio.warnswitchsta,
  warnlevel: state => state.vedio.warnlevel,
  warnplayend: state => state.vedio.warnplayend,
  switchAllStatus:state => state.vedio.switchAllStatus,
  autoplay:state => state.vedio.autoplay,
}
export default getters
